import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import Headline from '../../../ui/Headline';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { useNavigate } from 'react-router-dom';
import { getInstitutions, mapInstitutionsResponse } from '../../../api/admin/institutions';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { generateIdRoutePath } from '../../../helpers';
import SuperAdminUnitsPageLayout from '../../../layout/SuperAdminUnitsPageLayout';
import SuperAdminUnitCard from '../../../ui/SuperAdminUnitCard';
import { useSelector } from 'react-redux';
import { selectInstitutions, selectInstitutionsCurrentPage, setInstitutions, setInstitutionsCurrentPage, } from '../../../store/adminSlices/institutions';
import Loader from '../../../ui/Loader';
import { INSTITUTIONS_LIST_PER_PAGE_ITEMS } from '../../../app.config.vars/stored';
import Pagination from '../../../components/Pagination';
import Button from '../../../ui/Button';
import DownloadIcon from '../../../assets/icons/download.svg';
import { downloadMailingList } from '../../../api/admin/mailingList';
const InstitutionsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const institutions = useSelector(selectInstitutions);
    const currentPage = useSelector(selectInstitutionsCurrentPage);
    const [totalPages, setTotalPages] = useState(1);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [institutionInteractionStatus, setInstitutionInteractionStatus] = useState(null);
    const fetchInstitutions = async () => {
        try {
            const institutions = await getInstitutions(currentPage);
            dispatch(setInstitutions(mapInstitutionsResponse(institutions)));
            setTotalPages(Math.ceil(institutions.pagination.totalItems / INSTITUTIONS_LIST_PER_PAGE_ITEMS));
        }
        catch (err) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    useEffect(() => {
        const updateInstitutions = async () => {
            setSubmitStatus('pending');
            await fetchInstitutions();
            setSubmitStatus(null);
        };
        updateInstitutions();
    }, [currentPage]);
    useEffect(() => {
        return () => {
            dispatch(setInstitutions(null));
            dispatch(setInstitutionsCurrentPage(1));
        };
    }, []);
    const [mailingListStatus, setMailingListStatus] = useState(null);
    const onDownloadMailingList = async () => {
        setMailingListStatus('pending');
        try {
            await downloadMailingList();
            setMailingListStatus('success');
        }
        catch (_) {
            setMailingListStatus('error');
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    const onEditInstitution = (institutionId) => {
        navigate(generateIdRoutePath(APP_ROUTES.editInstitution, String(institutionId)));
    };
    return (_jsx(SuperAdminUnitsPageLayout, { title: t('admin.institutions'), unit: 'institution', actions: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: () => navigate(APP_ROUTES.structureOverview), label: t('button.structure_overview'), variant: 'outlined' }), _jsx(Button, { onClick: onDownloadMailingList, label: t('button.export_mailing_list'), variant: 'outlined', icon: _jsx(DownloadIcon, {}), iconSize: 'small', disabled: mailingListStatus === 'pending' })] }), children: _jsxs("div", { className: 'super-admin-units', children: [institutions && institutions.length > 0 && (_jsx(Headline, { title: t('admin.your_institutions'), type: 'h1' })), submitStatus !== 'pending' && institutions ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "institutions-list", children: institutions.map((institution) => (_jsx(SuperAdminUnitCard, { unitId: institution.id, unit: 'institution', email: institution.email, name: institution.name, isActive: institution.isActive, onUnitEdit: () => onEditInstitution(institution.id), submitStatus: institutionInteractionStatus, setSubmitStatus: setInstitutionInteractionStatus, newDocument: institution.newDocument, currentPage: currentPage, approvalStatus: institution.approvalStatus, editorCount: institution.editorCount }, institution.id))) }), totalPages > 1 && (_jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: (newPage) => dispatch(setInstitutionsCurrentPage(newPage)) }))] })) : (_jsx(Loader, {}))] }) }));
};
export default InstitutionsPage;
